export default __webpack_public_path__ + "static/media/gg8.9d05840d.jpeg";